<template>
  <BaseIcon v-bind="$attrs">
    <template #svg>
      <component
        :is="language"
        class="language"
        :class="`language--${language}`"
      />
    </template>
  </BaseIcon>
</template>

<script>
// Making a single icon component for all languages cause
// there's no use case they will not be loaded together.
// Do this wisely
import PtIcon from '@/assets/page-list-icons/pt.svg';
import EnIcon from '@/assets/page-list-icons/en.svg';
import EsIcon from '@/assets/page-list-icons/es.svg';
import BaseIcon from './BaseIcon.vue';

export default {
  name: 'IconLanguage',
  components: {
    BaseIcon,
    pt: PtIcon,
    en: EnIcon,
    es: EsIcon,
  },
  props: {
    language: {
      type: String,
      default: 'pt',
    },
  },
};
</script>
